import nextId from "react-id-generator"
import pic26 from "../../images/drmartens26.png"
import pic18 from "../../images/drmartens18.png"
import pic31 from "../../images/drmartens31.png"

export const boots = [
    {
        id: nextId(),
        tag: "sale",
        image: pic26,
        name: "Dr Martens Boots",
        price: "£199.99"
    },
    {
        id: nextId(),
        tag: "sale",
        image: pic18,
        name: "Dr Martens Boots",
        price: "£199.99"
    },
    {
        id: nextId(),
        tag: "sale",
        image: pic31,
        name: "Dr Martens Boots",
        price: "£199.99"
    },
]